import React from "react";

const MasterListToolbar = ({
  searchValue,
  onSearchChange,
  searchPlaceholder = "Search...",
  searchAriaLabel = "Search",
  filterValue = "",
  onFilterChange,
  filterOptions = [],
  filterAriaLabel = "Filter",
  filterPlaceholder = "All",
  onClear,
  showClear = false,
  minSearchWidth = "220px",
  minFilterWidth = "180px",
}) => (
  <div className="d-flex flex-wrap align-items-center gap-2">
    <input
      type="search"
      className="form-control form-control-sm"
      placeholder={searchPlaceholder}
      value={searchValue}
      onChange={onSearchChange}
      style={{ minWidth: minSearchWidth }}
      aria-label={searchAriaLabel}
    />
    {filterOptions.length > 0 && onFilterChange && (
      <select
        className="form-select form-select-sm"
        value={filterValue}
        onChange={onFilterChange}
        style={{ minWidth: minFilterWidth }}
        aria-label={filterAriaLabel}
      >
        <option value="">{filterPlaceholder}</option>
        {filterOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    )}
    {showClear && (
      <button
        type="button"
        className="btn btn-outline-secondary btn-sm"
        onClick={onClear}
        title="Clear filters"
        aria-label="Clear filters"
      >
        <i className="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    )}
  </div>
);

export default MasterListToolbar;
